module.exports = __webpack_public_path__ + "static/media/electronics.97ab346a.svg";